import React, { FC } from 'react';
import { NavItem } from './NavItem';
import { getIcon } from '../../../IconsMap/IconsMap';
import { ReactComponent as ExitIcon } from '../../../../assets/icons/exit.svg';
import styles from './NavMenu.module.css';
import User from '../../../../assets/icons/users.svg';
import { Authorize, BASE_BUCKET, BASE_IMAGE_URL, DEFAULT_ONEID_HOST } from '../../../../utils/constants';
import { generateEnvDomain } from '../../../../utils/generateEnvDomain';
import { Button } from '../Button/Button';
import { INavMenu, INavMenuMobile } from "../../../../declarations/types";


let defaultOneIdHost = DEFAULT_ONEID_HOST;
defaultOneIdHost = generateEnvDomain(defaultOneIdHost);

export const NavMenu: FC<INavMenu> = ({
  items,
  isAuth,
  isDark
}) => {

  const { hostname } = window.location;

  const hostNameLen = hostname.split('.');

  const isActive = (item: any): boolean => {
    const subDomen = new URL(item.route).host.split('.');
    return (hostNameLen.length > 2 && subDomen.length > 2
      ? hostNameLen.includes(subDomen[0])
      : hostNameLen[0] === subDomen[0]
    )
  }

  const getAuthRenderState = (condition: string, isAuth: boolean) => {
    const isAuthorized = condition === Authorize.signedIn && isAuth;
    const isUnauthorized = condition === Authorize.signedOut && !isAuth;
    const always = condition === Authorize.always;
    return always || isAuthorized || isUnauthorized || !condition;
  };

  return (
    <div className={styles.commonsNavMenu}>
      {items ? items.map((item) => {
        if (item.menu === null) item.menu = [];
        const IconPass = item.icon ? getIcon(item.icon) : getIcon('MonitorIcon');
        return (
          <NavItem
            key={item.name}
            route={item.route}
            className={styles.NavMenuItem}
            isActive={isActive(item)}
            label={/* item.translateKey || */item.title}
            icon={IconPass}
            shouldRender={getAuthRenderState(item.renderConditionString, isAuth)}
            isDark={isDark}
            subItem={item.menu}
          />
        );
      }) : <></>}
    </div>
  );
};

export const NavMenuMobile: FC<INavMenuMobile> = ({
  items,
  isAuth,
  photoUrl,
  userName,
  onLogout,
  onLogin,
  isNavBarHidden,
  isDark,
  s3Token,
}) => {
  const commonsNav = `${styles.commonsNavMobileMenu} ${isDark ? styles.commonsNavMobileMenuHeader : ''}`;
  const labelTheme = `${isDark ? styles.mobileMenuLabelDark : styles.mobileMenuLabel}`;
  const redirect = `${defaultOneIdHost}?redirect=${encodeURIComponent(window.location.origin)}`;
  const imageHost = generateEnvDomain(BASE_IMAGE_URL);
  const { hostname } = window.location;

  const hostNameLen = hostname.split('.');

  const isActive = (item: any): boolean => {
    const subDomen = new URL(item.route).host.split('.');
    return (hostNameLen.length > 2 && subDomen.length > 2
      ? hostNameLen.includes(subDomen[0])
      : hostNameLen[0] === subDomen[0]
    )
  }

  const onConfirmLogoutHandler = () => {
    if (onLogout) {
      onLogout();
    }
  };

  const onLoginHandler = () => {
    if (onLogin) {
      const isEnter = true;
      onLogin(isEnter);
    }
  };

  const redirectToProfile = () => {
    window.location.href = redirect
  }

  const avatarUrlFunc = (
    currentTarget: EventTarget & HTMLImageElement,
  ) => {
    if (currentTarget.src !== `${imageHost}/${photoUrl}?s3token=${s3Token}`) {
      currentTarget.src = `${imageHost}/${photoUrl}?s3token=${s3Token}`
    }
  };

  return (
    <nav className={commonsNav}>
      {!isNavBarHidden &&
        <ul className={styles.list}>
          {items && items.map((item) => {
            const IconPass = item.icon ? getIcon(item.icon) : getIcon('MonitorIcon');
            return (
              <li key={item.id}>
                <a className={isActive(item) ? styles.isActive : ''} href={item.route}>
                  {IconPass}
                  <span className={labelTheme}>{item.title}</span>
                </a>
              </li>
            );
          })}
        </ul>
      }

      {isAuth
        ? (
          <div className={styles.user}>
            <div className={styles.userInf} onClick={redirectToProfile}>
              <div className={styles.userAvatar}>
                {photoUrl ? (
                  <img
                    src={`${imageHost}/${BASE_BUCKET}/${photoUrl}?s3token=${s3Token}`}
                    alt="avatar_thumb"
                    onError={({ currentTarget }) => avatarUrlFunc(currentTarget)}
                  />
                ) : (
                  <img src={String(User)} alt="" />
                )}
              </div>

              <div className={styles.userName}>
                {userName || ''}
              </div>
            </div>
            <div onClick={onConfirmLogoutHandler} className={styles.exit}>
              <ExitIcon />
            </div>
          </div>
        )
        : <Button
          onClick={onLoginHandler}
        >
          Вход
        </Button>
      }
    </nav>
  );
}
